import propertyGif from "../../../assets/icons/money-bag.gif";
import { products } from "../../../constants/products";
import { UpsellCardBase } from "../../../components/UpsellCardBase";

export const PropertyDivisionUpsellCard: React.FC = ({}) => {
  const key = "financial_disclosures";
  const product = products[key];
  if (!product) return null;

  return (
    <UpsellCardBase
      productKey="financial_disclosures"
      title="Property Division"
      description="Catalog property, track debts, and generate clear records for negotiation or court filings. Our tools simplify the process so you can focus on moving forward."
      imageSrc={propertyGif}
      price={product.price}
    />
  );
};
